/*================ Getters ============*/
// auth module
export const IS_LOGGED_IN = 'isLoggedIn'
export const USER = 'user'
export const ADMIN_TYPING_ITEMS = 'adminTypingItems'
export const SENDING_PRODUCT = 'sendingProduct'
export const MERCHANT = 'merchant'
export const TOKEN = 'token'

/*============= Mutations ===============*/
// auth module
export const MUTATE_LOGIN = 'mutateLogin'
export const MUTATE_LOGOUT = 'mutateLogout'
export const MUTATE_START_SENDING_PRODUCT = 'mutantStartSendingProduct'
export const MUTATE_END_SENDING_PRODUCT = 'mutantEndSendingProduct'

/*=============== Actions =================*/
// auth module
export const LOGIN = 'login'
export const LOGOUT = 'logout'
export const START_SENDING_PRODUCT = 'startSendingProduct'
export const END_SENDING_PRODUCT = 'endSendingProduct'

/*=============== Backoffice Actions =================*/
// auth module
export const BACKOFFICE_LOGIN = 'backofficeLogin'
export const BACKOFFICE_LOGOUT = 'backofficeLogout'
export const BACKOFFICE_MUTATE_LOGIN = 'backofficeMutateLogin'
export const BACKOFFICE_MUTATE_LOGOUT = 'backofficeMutateLogout'
export const BACKOFFICE_IS_LOGGED_IN = 'backofficeIsLoggedIn'
export const BACKOFFICE_TOKEN = 'backofficeToken'
export const BACKOFFICE_USER = 'backofficeUser'



// WEBPACK FOOTER //
// ./src/vuex-store/types.js